'use client'
import axios from 'axios'
import axiosRetry from 'axios-retry'
import { SearchItem } from '../types'

import { getLocationTypeByQuery } from '@/app/utils'
import { buildFetchByDestcodeErrorMessage } from '../../../utils/sentry-errors'
import * as Sentry from '@sentry/nextjs'
import {
	HotelsAutosuggestRequest,
	HotelsAutosuggestResponse,
	HotelsQueryIncludedEntityTypesEnum,
} from '../types/skyscanner-wrapper-api'
import { transformHotelsPlacesToSearchItems } from '../utils/transform-hotels-place'
import { DEFAULT_SEARCH_ENTITIES } from '../constants'
import { getLanguageByLang } from '../languages'


const API_URL = process.env.NEXT_PUBLIC_SKYSCANNER_WRAPPER_API_URL

axiosRetry(axios, {
	retries: 3,
	retryDelay: (retryCount) => {
		console.log(`retry attempt: ${retryCount}`)
		return retryCount * 2000
	},
})

const sanitizeQuery = (query: string): string => {
	if (!query) return ''

	return query.replace(/&/g, ' ').replace(/\s+/g, ' ').trim()
}

export async function fetchAutocompleteResults(
	query: string,
	language = 'en',
	entityTypes?: HotelsQueryIncludedEntityTypesEnum[]
): Promise<SearchItem[]> {
	const { market, locale} = getLanguageByLang(language)
	const sanitizedQuery = sanitizeQuery(query)

	// TODO: fix market naming
	const request: HotelsAutosuggestRequest = {
		query: {
			market,
			locale,
			searchTerm: sanitizedQuery,
			// TODO: Refine included entities
			// includedEntityTypes: Object.values(HotelsQueryIncludedEntityTypesEnum),'
			includedEntityTypes: entityTypes || DEFAULT_SEARCH_ENTITIES,
		},
		limit: 10,
	}
	try {
		const res = await axios.post<
			HotelsAutosuggestRequest,
			{ data: HotelsAutosuggestResponse }
		>(`${API_URL}/api/v1/autosuggest/hotels`, request)

		/* const encodedQuery = encodeURIComponent(sanitizedQuery)

		const res = await axios.get<SearchItem[]>(
			`https://www.kayak.com/mvm/smartyv2/search?f=j&s=50&v=v1&lc=${langCode}&lc_cc=${countryCode}&where=${encodedQuery}`
		) */

		// TODO: temporary and will be replaced
		return transformHotelsPlacesToSearchItems(res.data.places || [])
	} catch (e) {
		Sentry.setContext('Request Params', {
			searchParams: JSON.stringify({ query, language }),
		})
		console.log('Error in Kayak Autocomplete:', e)
		Sentry.captureException(e)
	}

	return []
}

export const fetchLocationElasticSearch = async (query: string, lng = 'en') => {
	try {
		const endpoint = getLocationTypeByQuery(query)

		Sentry.setContext('Request Query', {
			searchParams: JSON.stringify(query),
		})

		const res = await axios.get(
			`${process.env.NEXT_PUBLIC_BACKEND_URL}/${endpoint}/${query}?lng=${lng}`
		)
		return res.data
	} catch (e: any) {
		console.log('Error in fetchLocationElasticSearch:', e)
		Sentry.captureException(buildFetchByDestcodeErrorMessage(e.message))
	}

	return null
}
